// colors.js — Single source of truth for all brand colors
// Import this wherever you need colors in JS/JSX
// CSS variables are auto-injected via GlobalColors component or colors.css

const colors = {
  // ── Brand Primary (Green) ──────────────────────────────
// ── Brand Primary (Golden) ──────────────────────────────
primary:         '#C8A04A',   // rich gold — buttons, links
primary_dark:    '#A67C2E',   // hover / pressed gold
primary_light:   '#E0B85C',   // lighter gold — highlights
primary_xlight:  '#F3D48A',   // soft gold accent
primary_bg:      '#FFF8E6',   // subtle gold tint background
primary_border:  '#E6C97A',   // gold border
primary_glow:    'rgba(200, 160, 74, 0.25)',  // glow/shadow

  // ── Form Primary (Navy Blue — ProeprtyCreate/FormComponents) ──
  form_primary:    '#1a2b4a',
  form_primary_l:  '#243a63',
  form_accent:     '#c8a04a',
  form_accent_l:   '#e0b85c',

  // ── Neutral ────────────────────────────────────────────
  white:           '#ffffff',
  bg:              '#f5f7f5',   // page background (home, auth)
  bg_form:         '#f4f6f9',   // form page background
  bg_input:        '#f9faf9',   // input field background
  bg_card:         '#ffffff',   // card / panel white
  border:          '#e0e7e0',   // input borders
  border_light:    '#e8f0e8',   // header / divider borders

  // ── Text ───────────────────────────────────────────────
  text:            '#1a1a1a',   // primary body text
  text_sub:        '#666',      // secondary / muted text
  text_placeholder:'#aab5aa',  // input placeholder
  text_label:      '#6b6b6b',   // form label

  // ── Semantic ───────────────────────────────────────────
  error:           '#e53e3e',
  success:         '#38a169',
  warning:         '#d97706',
  info:            '#2563eb',   // SelectScreens / TypeCategorySelect blue

  // ── Dark surfaces (footer, shorts, WhyChooseUs) ────────
  dark_bg:         '#0f1a0f',   // shorts section bg
  dark_footer:     '#1a2b1a',   // footer bg
  dark_card:       '#1a2b1a',   // short card bg
  dark_overlay:    'rgba(0, 0, 0, 0.55)',

  // ── Shorts / YouTube ───────────────────────────────────
  youtube_red:     '#ff0000',

  // ── Ad / OTP ───────────────────────────────────────────
  ad_overlay:      'rgba(0, 0, 0, 0.65)',
  otp_focus_glow:  'rgba(200, 160, 74, 0.10)',
};

export default colors;